'use client';

import Image from 'next/image';
import { AppPromotionButton } from '../AppPromotionButton';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

export const ClientMobileButton = () => {
  const t = useTranslations();

  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const goingDown = currentScrollY > lastScrollY.current;

      if (goingDown && currentScrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AppPromotionButton
      linkHref='/product/create'
      eventName='ad_create_button'
      className={clsx(
        'lg:hidden fixed text-m bottom-[16px] z-30 w-[343px] left-[calc(50%-172px)] justify-center py-[10px] flex items-center gap-[8px] text-white font-medium bg-main-green rounded-[12px] transition-transform duration-300 ease-in-out',
        !isVisible && 'translate-y-[100px]',
      )}
    >
      <Image width={24} height={24} src='/assets/icons/plus-white.svg' className='w-[24px] h-[24px]' alt='' />
      <span>{t('controls.header.advertisement')}</span>
    </AppPromotionButton>
  );
};
